
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {OrderInsertRequestParams} from './OrderInsertRequestParams';
import {FieldModelOrderInsertRequestParams} from './OrderInsertRequestParams';
import {OrderUpdateRequestParams} from './OrderUpdateRequestParams';
import {FieldModelOrderUpdateRequestParams} from './OrderUpdateRequestParams';
import {OrderDeleteRequestParams} from './OrderDeleteRequestParams';
import {FieldModelOrderDeleteRequestParams} from './OrderDeleteRequestParams';
import {AccountUpdateRequestParams} from './AccountUpdateRequestParams';
import {FieldModelAccountUpdateRequestParams} from './AccountUpdateRequestParams';
import {OrderSplitRequestParams} from './OrderSplitRequestParams';
import {FieldModelOrderSplitRequestParams} from './OrderSplitRequestParams';

/**
 * MassRequestParams struct
 */
class MassRequestParams {
  /**
   * Initialize struct
   * @param {OrderInsertRequestParams=} orderToInsert
   * @param {OrderUpdateRequestParams=} orderToUpdate
   * @param {OrderDeleteRequestParams=} orderToDelete
   * @param {AccountUpdateRequestParams=} accountToUpdate
   * @param {AccountUpdateRequestParams=} socialTradingCommissionsInvestor
   * @param {AccountUpdateRequestParams=} socialTradingCommissionsMaster
   * @param {AccountUpdateRequestParams=} dividendsAdjustment
   * @param {OrderSplitRequestParams=} orderToSplit
   * @constructor
   */
  constructor (orderToInsert = null, orderToUpdate = null, orderToDelete = null, accountToUpdate = null, socialTradingCommissionsInvestor = null, socialTradingCommissionsMaster = null, dividendsAdjustment = null, orderToSplit = null) {
    this.OrderToInsert = orderToInsert
    this.OrderToUpdate = orderToUpdate
    this.OrderToDelete = orderToDelete
    this.AccountToUpdate = accountToUpdate
    this.SocialTradingCommissionsInvestor = socialTradingCommissionsInvestor
    this.SocialTradingCommissionsMaster = socialTradingCommissionsMaster
    this.DividendsAdjustment = dividendsAdjustment
    this.OrderToSplit = orderToSplit
  }

  /**
   * Copy struct (shallow copy)
   * @this {!MassRequestParams}
   * @param {!MassRequestParams} other Other struct
   * @returns {!MassRequestParams} This struct
   */
  copy (other) {
    if (other.OrderToInsert != null) {
      this.OrderToInsert = OrderInsertRequestParams.fromObject(other.OrderToInsert)
    } else {
      this.OrderToInsert = null
    }
    if (other.OrderToUpdate != null) {
      this.OrderToUpdate = OrderUpdateRequestParams.fromObject(other.OrderToUpdate)
    } else {
      this.OrderToUpdate = null
    }
    if (other.OrderToDelete != null) {
      this.OrderToDelete = OrderDeleteRequestParams.fromObject(other.OrderToDelete)
    } else {
      this.OrderToDelete = null
    }
    if (other.AccountToUpdate != null) {
      this.AccountToUpdate = AccountUpdateRequestParams.fromObject(other.AccountToUpdate)
    } else {
      this.AccountToUpdate = null
    }
    if (other.SocialTradingCommissionsInvestor != null) {
      this.SocialTradingCommissionsInvestor = AccountUpdateRequestParams.fromObject(other.SocialTradingCommissionsInvestor)
    } else {
      this.SocialTradingCommissionsInvestor = null
    }
    if (other.SocialTradingCommissionsMaster != null) {
      this.SocialTradingCommissionsMaster = AccountUpdateRequestParams.fromObject(other.SocialTradingCommissionsMaster)
    } else {
      this.SocialTradingCommissionsMaster = null
    }
    if (other.DividendsAdjustment != null) {
      this.DividendsAdjustment = AccountUpdateRequestParams.fromObject(other.DividendsAdjustment)
    } else {
      this.DividendsAdjustment = null
    }
    if (other.OrderToSplit != null) {
      this.OrderToSplit = OrderSplitRequestParams.fromObject(other.OrderToSplit)
    } else {
      this.OrderToSplit = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!MassRequestParams}
   * @returns {!MassRequestParams} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new MassRequestParamsModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new MassRequestParamsModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!MassRequestParams}
   * @param {!MassRequestParams} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof MassRequestParams)) {
      throw new TypeError('Instance of MassRequestParams is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!MassRequestParams}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      OrderToInsert: ((this.OrderToInsert != null) ? this.OrderToInsert : null),
      OrderToUpdate: ((this.OrderToUpdate != null) ? this.OrderToUpdate : null),
      OrderToDelete: ((this.OrderToDelete != null) ? this.OrderToDelete : null),
      AccountToUpdate: ((this.AccountToUpdate != null) ? this.AccountToUpdate : null),
      SocialTradingCommissionsInvestor: ((this.SocialTradingCommissionsInvestor != null) ? this.SocialTradingCommissionsInvestor : null),
      SocialTradingCommissionsMaster: ((this.SocialTradingCommissionsMaster != null) ? this.SocialTradingCommissionsMaster : null),
      DividendsAdjustment: ((this.DividendsAdjustment != null) ? this.DividendsAdjustment : null),
      OrderToSplit: ((this.OrderToSplit != null) ? this.OrderToSplit : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return MassRequestParams.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!MassRequestParams} other Object value
   * @returns {!MassRequestParams} Created struct
   */
  static fromObject (other) {
    return new MassRequestParams().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!MassRequestParams}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return MassRequestParams.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!MassRequestParams}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4139
  }
}

export { MassRequestParams };

/**
 * Fast Binary Encoding MassRequestParams field model
 */
class FieldModelMassRequestParams extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.OrderToInsert = new fbe.FieldModelOptional(new FieldModelOrderInsertRequestParams(buffer, 4 + 4), buffer, 4 + 4)
    this.OrderToUpdate = new fbe.FieldModelOptional(new FieldModelOrderUpdateRequestParams(buffer, this.OrderToInsert.fbeOffset + this.OrderToInsert.fbeSize), buffer, this.OrderToInsert.fbeOffset + this.OrderToInsert.fbeSize)
    this.OrderToDelete = new fbe.FieldModelOptional(new FieldModelOrderDeleteRequestParams(buffer, this.OrderToUpdate.fbeOffset + this.OrderToUpdate.fbeSize), buffer, this.OrderToUpdate.fbeOffset + this.OrderToUpdate.fbeSize)
    this.AccountToUpdate = new fbe.FieldModelOptional(new FieldModelAccountUpdateRequestParams(buffer, this.OrderToDelete.fbeOffset + this.OrderToDelete.fbeSize), buffer, this.OrderToDelete.fbeOffset + this.OrderToDelete.fbeSize)
    this.SocialTradingCommissionsInvestor = new fbe.FieldModelOptional(new FieldModelAccountUpdateRequestParams(buffer, this.AccountToUpdate.fbeOffset + this.AccountToUpdate.fbeSize), buffer, this.AccountToUpdate.fbeOffset + this.AccountToUpdate.fbeSize)
    this.SocialTradingCommissionsMaster = new fbe.FieldModelOptional(new FieldModelAccountUpdateRequestParams(buffer, this.SocialTradingCommissionsInvestor.fbeOffset + this.SocialTradingCommissionsInvestor.fbeSize), buffer, this.SocialTradingCommissionsInvestor.fbeOffset + this.SocialTradingCommissionsInvestor.fbeSize)
    this.DividendsAdjustment = new fbe.FieldModelOptional(new FieldModelAccountUpdateRequestParams(buffer, this.SocialTradingCommissionsMaster.fbeOffset + this.SocialTradingCommissionsMaster.fbeSize), buffer, this.SocialTradingCommissionsMaster.fbeOffset + this.SocialTradingCommissionsMaster.fbeSize)
    this.OrderToSplit = new fbe.FieldModelOptional(new FieldModelOrderSplitRequestParams(buffer, this.DividendsAdjustment.fbeOffset + this.DividendsAdjustment.fbeSize), buffer, this.DividendsAdjustment.fbeOffset + this.DividendsAdjustment.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelMassRequestParams}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelMassRequestParams}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.OrderToInsert.fbeSize + this.OrderToUpdate.fbeSize + this.OrderToDelete.fbeSize + this.AccountToUpdate.fbeSize + this.SocialTradingCommissionsInvestor.fbeSize + this.SocialTradingCommissionsMaster.fbeSize + this.DividendsAdjustment.fbeSize + this.OrderToSplit.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelMassRequestParams}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.OrderToInsert.fbeExtra + this.OrderToUpdate.fbeExtra + this.OrderToDelete.fbeExtra + this.AccountToUpdate.fbeExtra + this.SocialTradingCommissionsInvestor.fbeExtra + this.SocialTradingCommissionsMaster.fbeExtra + this.DividendsAdjustment.fbeExtra + this.OrderToSplit.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelMassRequestParams}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelMassRequestParams.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelMassRequestParams}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4139
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelMassRequestParams}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelMassRequestParams}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.OrderToInsert.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderToInsert.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderToInsert.fbeSize

    if ((fbeCurrentSize + this.OrderToUpdate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderToUpdate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderToUpdate.fbeSize

    if ((fbeCurrentSize + this.OrderToDelete.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderToDelete.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderToDelete.fbeSize

    if ((fbeCurrentSize + this.AccountToUpdate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountToUpdate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountToUpdate.fbeSize

    if ((fbeCurrentSize + this.SocialTradingCommissionsInvestor.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingCommissionsInvestor.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingCommissionsInvestor.fbeSize

    if ((fbeCurrentSize + this.SocialTradingCommissionsMaster.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingCommissionsMaster.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingCommissionsMaster.fbeSize

    if ((fbeCurrentSize + this.DividendsAdjustment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DividendsAdjustment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DividendsAdjustment.fbeSize

    if ((fbeCurrentSize + this.OrderToSplit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderToSplit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderToSplit.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelMassRequestParams}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelMassRequestParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelMassRequestParams}
   * @param {!MassRequestParams} fbeValue Default value, defaults is new MassRequestParams()
   * @returns {!MassRequestParams} MassRequestParams value
   */
  get (fbeValue = new MassRequestParams()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelMassRequestParams}
   * @param {!MassRequestParams} fbeValue MassRequestParams value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.OrderToInsert.fbeSize) <= fbeStructSize) {
      fbeValue.OrderToInsert = this.OrderToInsert.get()
    } else {
      fbeValue.OrderToInsert = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderToInsert.fbeSize

    if ((fbeCurrentSize + this.OrderToUpdate.fbeSize) <= fbeStructSize) {
      fbeValue.OrderToUpdate = this.OrderToUpdate.get()
    } else {
      fbeValue.OrderToUpdate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderToUpdate.fbeSize

    if ((fbeCurrentSize + this.OrderToDelete.fbeSize) <= fbeStructSize) {
      fbeValue.OrderToDelete = this.OrderToDelete.get()
    } else {
      fbeValue.OrderToDelete = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderToDelete.fbeSize

    if ((fbeCurrentSize + this.AccountToUpdate.fbeSize) <= fbeStructSize) {
      fbeValue.AccountToUpdate = this.AccountToUpdate.get()
    } else {
      fbeValue.AccountToUpdate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountToUpdate.fbeSize

    if ((fbeCurrentSize + this.SocialTradingCommissionsInvestor.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingCommissionsInvestor = this.SocialTradingCommissionsInvestor.get()
    } else {
      fbeValue.SocialTradingCommissionsInvestor = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingCommissionsInvestor.fbeSize

    if ((fbeCurrentSize + this.SocialTradingCommissionsMaster.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingCommissionsMaster = this.SocialTradingCommissionsMaster.get()
    } else {
      fbeValue.SocialTradingCommissionsMaster = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingCommissionsMaster.fbeSize

    if ((fbeCurrentSize + this.DividendsAdjustment.fbeSize) <= fbeStructSize) {
      fbeValue.DividendsAdjustment = this.DividendsAdjustment.get()
    } else {
      fbeValue.DividendsAdjustment = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DividendsAdjustment.fbeSize

    if ((fbeCurrentSize + this.OrderToSplit.fbeSize) <= fbeStructSize) {
      fbeValue.OrderToSplit = this.OrderToSplit.get()
    } else {
      fbeValue.OrderToSplit = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderToSplit.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelMassRequestParams}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelMassRequestParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelMassRequestParams}
   * @param {!MassRequestParams} fbeValue MassRequestParams value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelMassRequestParams}
   * @param {MassRequestParams} fbeValue MassRequestParams value
   */
  setFields (fbeValue) {
    this.OrderToInsert.set(fbeValue.OrderToInsert)
    this.OrderToUpdate.set(fbeValue.OrderToUpdate)
    this.OrderToDelete.set(fbeValue.OrderToDelete)
    this.AccountToUpdate.set(fbeValue.AccountToUpdate)
    this.SocialTradingCommissionsInvestor.set(fbeValue.SocialTradingCommissionsInvestor)
    this.SocialTradingCommissionsMaster.set(fbeValue.SocialTradingCommissionsMaster)
    this.DividendsAdjustment.set(fbeValue.DividendsAdjustment)
    this.OrderToSplit.set(fbeValue.OrderToSplit)
  }
}

export { FieldModelMassRequestParams };

/**
 * Fast Binary Encoding MassRequestParams model
 */
class MassRequestParamsModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelMassRequestParams(this.buffer, 4)
  }

  /**
   * Get the MassRequestParams model
   * @this {!MassRequestParamsModel}
   * @returns {!FieldModelMassRequestParams} model MassRequestParams model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!MassRequestParamsModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!MassRequestParamsModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return MassRequestParamsModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!MassRequestParamsModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelMassRequestParams.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!MassRequestParamsModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!MassRequestParamsModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!MassRequestParamsModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!MassRequestParamsModel}
   * @param {!MassRequestParams} value MassRequestParams value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!MassRequestParamsModel}
   * @param {!MassRequestParams} value MassRequestParams value, defaults is new MassRequestParams()
   * @return {!object} Deserialized MassRequestParams value and its size
   */
  deserialize (value = new MassRequestParams()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new MassRequestParams(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new MassRequestParams(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!MassRequestParamsModel}
   * @param {!number} prev Previous MassRequestParams model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { MassRequestParamsModel };
